import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { VStack, Image, Text } from "@chakra-ui/react";
import { IMG_URL } from "./common/Constant";
const NothingFound = ({ text = (_jsxs(_Fragment, { children: ["Am I too drunk? ", _jsx("br", {}), "My antennas can\u2019t find anything here"] })), textColor = "whiteAlpha.700", }) => {
    return (_jsxs(VStack, { textAlign: "center", children: [_jsx(Image, { src: `${IMG_URL}/icons/nothing.png` }), _jsx(Text, { fontSize: "sm", color: textColor, children: text })] }));
};
export default NothingFound;
